__turbopack_context__.v({
  "centerContent": "SchoolBlocksHeader-module-scss-module__-8S65W__centerContent",
});
